import { render, staticRenderFns } from "./second_step.vue?vue&type=template&id=0a35c84f"
import script from "./second_step.vue?vue&type=script&lang=js"
export * from "./second_step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports